function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "icon-shorttime-accident");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M262.76,813.29v7.83a3.34,3.34,0,0,1-3.61,3.33l-15.21-.55a24.59,24.59,0,0,0-14.82,4.31l-8.2,6.25a37.32,37.32,0,0,1-26.42,7.45L95.36,831.78a32.81,32.81,0,0,1-24.43-15.17,102.32,102.32,0,0,1-9-17.93h0A102.66,102.66,0,0,1,56.13,776l-0.76-5.49a2.48,2.48,0,0,1,1.54-2.65l3.8-1.51a27.08,27.08,0,0,1,17.47-.86l12.43,3.57L96,770.64l4.19,1.2,0.62,0.18,0.85,0.23a28.54,28.54,0,0,0,14.57-.13l0.49-.11h0a9.43,9.43,0,0,1,3.93,0l14.9,3.1,24.36,5.06,1.52,0.32,3.1,0.64,12.74,2.65,1.74,0.36,12.19,2.53a96.4,96.4,0,0,1,10.13,2.69h0a96.26,96.26,0,0,1,27.35,14l0.94,0.69A31.14,31.14,0,0,0,245.19,810l15.95,1.51A1.79,1.79,0,0,1,262.76,813.29Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M198.33,842.35a37.89,37.89,0,0,1-3.86-.2L95.34,832a33.05,33.05,0,0,1-24.61-15.28,102.79,102.79,0,0,1-9-17.9l0,0v-0.09A103,103,0,0,1,55.89,776l-0.76-5.49a2.72,2.72,0,0,1,1.69-2.91l3.8-1.51a27.46,27.46,0,0,1,17.63-.86l22.65,6.51,0.84,0.23a28.43,28.43,0,0,0,14.45-.13l0.31-.08h0l0.19,0a9.63,9.63,0,0,1,4,0l70.55,14.66a97,97,0,0,1,10.12,2.68h0.06l0,0a96.33,96.33,0,0,1,27.37,14.06l0.94,0.69a30.91,30.91,0,0,0,15.41,5.88l15.95,1.51a2,2,0,0,1,1.84,2v7.83a3.59,3.59,0,0,1-3.87,3.58l-15.2-.55a24.51,24.51,0,0,0-14.67,4.27l-8.19,6.25A37.43,37.43,0,0,1,198.33,842.35ZM62.16,798.53h0l0,0.05a102.31,102.31,0,0,0,8.95,17.89,32.57,32.57,0,0,0,24.25,15.06l99.13,10.14a37,37,0,0,0,26.25-7.4L229,828a25,25,0,0,1,15-4.36l15.22,0.55a3.1,3.1,0,0,0,3.36-3.09v-7.83a1.54,1.54,0,0,0-1.4-1.54l-15.95-1.51a31.39,31.39,0,0,1-15.65-6l-0.94-.69a95.84,95.84,0,0,0-27.29-14l-0.06,0a96.52,96.52,0,0,0-10-2.66l-70.55-14.66a9.14,9.14,0,0,0-3.64,0v0h-0.22l-0.45.11a28.92,28.92,0,0,1-14.7.13l-0.86-.23-10.23-2.94-12.43-3.57a27,27,0,0,0-17.31.85L57,768.1a2.24,2.24,0,0,0-1.39,2.39L56.37,776A102.57,102.57,0,0,0,62.16,798.53Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M82.14,825.06c-3.45-23.84-14.72-58.13-14.83-58.47l0.15-.05c0.11,0.34,11.38,34.64,14.84,58.5Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M93.63,828.44h-0.1c-0.08,0-7.79-1-11.87-3.62-2-1.26-7.39-6.38-15.36-26.53a111.41,111.41,0,0,1-7-26.09,4.18,4.18,0,0,1,1.83-4,7.44,7.44,0,0,1,2.18-1,21.2,21.2,0,0,1,9.14-.38l0.54,0.1a12,12,0,0,1,8.61,6.46l2.08,4.2a26.47,26.47,0,0,0,10,10.7,32.76,32.76,0,0,0,10.48,4.6c0.09,0,8.73,1.91,9.65,2.07,30.18,5.41,54.56,9.34,82.8,12.16l59.6,6.11a4.44,4.44,0,0,1,3.92,3.64l0,2.33a1.32,1.32,0,0,1-.31,1.09,1.33,1.33,0,0,1-1,.46l-26.9-1.13c-1-.1-101.92-10.21-131.85-14.73a6.44,6.44,0,0,0-7.38,6.77Zm-11.88-3.77c3.81,2.45,10.8,3.46,11.71,3.58l-1-16.57a6.6,6.6,0,0,1,7.57-6.94c29.93,4.53,130.83,14.63,131.84,14.73l26.9,1.13a1.18,1.18,0,0,0,1.19-1.38l0-2.33a4.28,4.28,0,0,0-3.78-3.5l-59.6-6.11c-28.24-2.82-52.62-6.74-82.81-12.16-0.92-.16-9.56-2.05-9.65-2.07a32.91,32.91,0,0,1-10.53-4.62,26.63,26.63,0,0,1-10-10.77l-2.08-4.2a11.86,11.86,0,0,0-8.49-6.38L72.4,767a21,21,0,0,0-9.07.37,7.28,7.28,0,0,0-2.13,1,4,4,0,0,0-1.76,3.84,111.24,111.24,0,0,0,7,26.05C74.41,818.33,79.8,823.41,81.75,824.67Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M74.79,791.57a50.44,50.44,0,0,1-6-1.77c-4.1-1.52-6.42-3.15-6.91-4.84l0.16,0c1.13,3.93,12.67,6.48,12.79,6.5Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M81.84,823s-4.15-3.89-8.94-14.88c-2.74-6.27-5.1-11.71-6.32-14.78a1.23,1.23,0,0,1,1.6-1.6,29.29,29.29,0,0,0,7.23,1.91l0,0.16a29.45,29.45,0,0,1-7.28-1.92,1.07,1.07,0,0,0-1.39,1.39c1.22,3.07,3.58,8.5,6.32,14.77,4.78,11,8.87,14.79,8.91,14.82Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M90.36,827.82c0-.1-0.88-10.07-1.52-17.62a6.26,6.26,0,0,1,7.62-6.63l15.91,2.86,0,0.16-15.91-2.86A6.1,6.1,0,0,0,89,810.19c0.64,7.55,1.51,17.52,1.52,17.62H90.36Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M74,788.74l-3.83-1.39a11.74,11.74,0,0,1-7.23-7.67l-3-10.21,0.15,0,3,10.21a11.58,11.58,0,0,0,7.13,7.56l3.83,1.39Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M199,838.19q-1,0-2-.07c-27.36-1.83-92.23-6.83-103.7-13.79l0.08-.14C104.77,831.13,169.61,836.13,197,838a30.17,30.17,0,0,0,22-7.48c8-7.1,12.37-10.8,12.85-11l0.06,0.15c-0.32.13-2.8,2.15-12.81,11A30.34,30.34,0,0,1,199,838.19Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M192.64,835.25l-1.2,0c-11.35-.55-33.44-1.8-53.81-3.94-24.52-2.58-39.5-5.67-44.53-9.19l0.09-.13c5,3.51,20,6.59,44.46,9.16,20.36,2.14,42.45,3.39,53.8,3.94a24.35,24.35,0,0,0,16.6-5.45l13.67-11.14,0.1,0.13-13.67,11.14A24.51,24.51,0,0,1,192.64,835.25Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M230.88,808.69h0c-1.73-.23-5.62-0.71-11-1.37-21.7-2.67-66.84-8.24-84.83-11.43-8.56-1.52-17-3.22-25.08-5.06l-0.47-.11-1-.23-4.13-1-1.51-.37-1.8-.45-1.72-.44-2.12-.56,0-.16,2.12,0.56,1.72,0.44,1.8,0.45,1.51,0.37,4.13,1,1,0.23,0.47,0.11c8.08,1.84,16.51,3.54,25.08,5.06,18,3.19,63.12,8.75,84.82,11.43,5.38,0.66,9.27,1.14,11,1.37a0.17,0.17,0,0,0,.18-0.11,0.17,0.17,0,0,0-.06-0.21c-4.1-3-18.36-13.37-29.65-18.8l0,0,0.05-.05v-0.09l0,0h0C212.71,794.7,227,805,231.08,808.08A0.34,0.34,0,0,1,230.88,808.69Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref14 =
/*#__PURE__*/
React.createElement("rect", {
  className: "cls-1",
  x: 225.7,
  y: 800.54,
  width: 0.16,
  height: 11.22,
  transform: "matrix(0.35, -0.94, 0.94, 0.35, -663.17, -32.63)"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M253.73,815.74c-0.63-.06-63.6-6.53-104.06-11.1-21.29-2.4-35.62-5.39-43.89-7.47-9.14-2.3-13.32-4.08-13.63-4.26l0.08-.14c0.31,0.19,4.47,2,13.59,4.25,8.27,2.08,22.59,5.06,43.87,7.47,40.45,4.57,103.42,11,104.05,11.1Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M253.73,818.05c-0.66-.06-66.43-6.12-106.92-10.35-21.31-2.23-35.66-5.09-44-7.11-9.16-2.22-13.35-4-13.67-4.15l0.08-.14c0.31,0.18,4.48,1.91,13.63,4.13,8.28,2,22.63,4.88,43.93,7.1,40.49,4.23,106.26,10.29,106.92,10.35v0.16Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M80.76,818.2c-1.62,0-2.81-1.65-3.26-2.26a2.67,2.67,0,0,0-.18-0.23l0.11-.12a2.42,2.42,0,0,1,.2.25c0.48,0.65,1.59,2.16,3.13,2.19v0.16Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M80.1,815.48A5.56,5.56,0,0,1,76.26,813l-0.14-.17,0.11-.12,0.16,0.19a5.41,5.41,0,0,0,3.72,2.41v0.16Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M79.43,812.77A6.28,6.28,0,0,1,75,810.09l-0.1-.13,0.11-.12L75.15,810a6.12,6.12,0,0,0,4.29,2.61Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M78.77,810a7.3,7.3,0,0,1-5-2.87l-0.08-.1,0.11-.12,0.09,0.12a7.15,7.15,0,0,0,4.86,2.8Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M78.1,807.33a8.36,8.36,0,0,1-5.53-3.05l-0.05-.07,0.11-.12,0.07,0.09a8.2,8.2,0,0,0,5.43,3Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M77.44,804.61c-1.25-.2-4.34-0.92-6.09-3.23l0,0,0.11-.12,0.05,0.06c1.72,2.27,4.76,3,6,3.17Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M76.78,801.89c-1.1-.19-4.83-1-6.65-3.41l0,0,0.11-.11,0,0c0.45,0.6,2.25,2.61,6.55,3.35Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M76.11,799.17c-5-.9-6.88-3.15-7.2-3.59l0.11-.12,0,0c0.32,0.43,2.14,2.63,7.1,3.52Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M75.45,796.45a16.3,16.3,0,0,1-6.12-2.3,6.13,6.13,0,0,1-1.63-1.47l0.13-.09s1.79,2.59,7.65,3.69Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M71.42,784.49c-5.37-1.79-7.34-3.83-7.36-3.85l0.12-.11s2,2,7.29,3.81Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M70.76,782.13c-5.09-1.53-7.24-3.7-7.26-3.72l0.12-.11s2.14,2.16,7.19,3.68Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M70.1,779.77a16.62,16.62,0,0,1-7.15-3.59l0.11-.11a16.47,16.47,0,0,0,7.08,3.55Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M69.44,777.41A15.44,15.44,0,0,1,62.39,774l0.11-.11a15.28,15.28,0,0,0,7,3.41Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M68.79,775.05a14.32,14.32,0,0,1-6.95-3.32l0.11-.12a14.15,14.15,0,0,0,6.86,3.28Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M68.13,772.7a13.24,13.24,0,0,1-6.85-3.19l0.11-.12a13.07,13.07,0,0,0,6.76,3.15Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M150.37,789.42h-3.43v-0.16h3.43a3.57,3.57,0,0,0,3-1.62l2.48-3.8a11.41,11.41,0,0,1,4.06-3.76l0.08,0.14a11.25,11.25,0,0,0-4,3.71l-2.48,3.8A3.73,3.73,0,0,1,150.37,789.42Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M156,794.14l-0.16,0c0-.1,1.44-10.22,5.61-13.72l0.1,0.12C157.4,784,156,794,156,794.14Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M179.34,794.13c0-.39-0.46-9.62-0.38-10l0.16,0c-0.06.32,0.22,6.68,0.38,10h-0.16Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M172.16,795.73h-8.25a10.51,10.51,0,0,1-4.66-1.1l-0.23-.11,0.07-.14,0.23,0.11a10.35,10.35,0,0,0,4.59,1.08h8.25a15,15,0,0,0,6.39-1.19l0.07,0.14A15.18,15.18,0,0,1,172.16,795.73Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M169.29,793.51a41.31,41.31,0,0,1-7.33-.6,0.46,0.46,0,0,1-.32-0.24c-0.9-1.59,2.7-11.19,2.86-11.59l0.15,0.06c0,0.1-3.73,9.93-2.87,11.46a0.3,0.3,0,0,0,.21.16,51,51,0,0,0,14,.24,1.43,1.43,0,0,0,1.22-1.45v-7.79h0.16v7.79a1.59,1.59,0,0,1-1.37,1.61C173.61,793.39,171.37,793.51,169.29,793.51Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M89.82,779.56l-0.15-.07c0-.07,3.14-6.78,6.31-8.93l0.09,0.13C92.94,772.82,89.85,779.5,89.82,779.56Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M103.25,785.13a47.23,47.23,0,0,1-9.32-.82l-0.07,0v-0.07c0-.08,1.31-8.1,6.29-12.43l0.11,0.12C95.59,776,94.19,783.34,94,784.16a53.6,53.6,0,0,0,17.67.17l0,0.16A56.58,56.58,0,0,1,103.25,785.13Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M124.61,787a56.88,56.88,0,0,1-10.68-1c-1.93-.37-2.24-0.81-2.27-0.86v0a15.28,15.28,0,0,1,.31-2.61,31.78,31.78,0,0,1,4.71-10.5v-0.05h0.08V772h0.08v0.08h0a31.57,31.57,0,0,0-4.67,10.43,15.13,15.13,0,0,0-.31,2.55,4.16,4.16,0,0,0,2.15.77,58.21,58.21,0,0,0,15.13.82c5.84-.43,8.15-2.28,8.18-2.3l0.1,0.12s-2.37,1.9-8.27,2.34C127.61,786.93,126.11,787,124.61,787Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M136.2,783.93H136c0.07-1.43-.4-8.53-0.52-8.8l0.14-.08A86.35,86.35,0,0,1,136.2,783.93Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M220.06,806h-0.12c-18.1-1.94-91.55-11-120.26-19.74a57,57,0,0,1-9.32-3.51,3.13,3.13,0,0,0-.36-0.17v-0.16a1.64,1.64,0,0,1,.42.18,56.86,56.86,0,0,0,9.3,3.5c28.69,8.75,102.14,17.79,120.23,19.73a0.86,0.86,0,0,0,.53-1.6l-29.3-17.52,0.08-.14,29.3,17.52A1,1,0,0,1,220.06,806Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M124.79,788.89a109.12,109.12,0,0,1-25.1-2.63l0-.16c0.15,0,14.84,3.85,35.3,2.21v0.16C131.42,788.77,128,788.89,124.79,788.89Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M122.84,785.11a27.38,27.38,0,0,1-6.93-.65c-1.18-.36-1.77-0.86-1.76-1.49,0-1.81,1.25-4.6,2.27-6.63a28.61,28.61,0,0,1,2.36-4.07v0.08l0,0.06c-0.18.18-4.48,7.14-4.53,10.56,0,0.55.55,1,1.65,1.34,2.85,0.86,8.38.67,10.63,0.55,4.26-.23,7.21-0.73,7.36-1,0.36-.57.17-4.52,0.06-6.89,0-.87-0.07-1.56-0.07-1.91h0.16c0,0.35,0,1,.07,1.91,0.16,3.36.27,6.42-.09,7S128,785.11,122.84,785.11Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M102.75,783.24c-1.53,0-3,0-4.34-.1a2.13,2.13,0,0,1-1.92-2.74,20.45,20.45,0,0,1,5.15-8.2l0.11,0.12a20.28,20.28,0,0,0-5.1,8.12A2,2,0,0,0,98.42,783c4.61,0.25,11.56.06,13.6-.55l0,0.15A46.49,46.49,0,0,1,102.75,783.24Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M97.63,819.14l-0.14-.07,4.26-8.16a6.69,6.69,0,0,1,6.08-3.61l13.32,0.24v0.16l-13.32-.24A6.52,6.52,0,0,0,101.9,811Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M144.57,826.36c-0.19,0-18.61-.08-25.86-0.49a40.62,40.62,0,0,1-13.45-3.31l0.07-.15a40.45,40.45,0,0,0,13.39,3.3c7.24,0.41,25.66.49,25.85,0.49v0.16Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M142.41,828.48c-31.33,0-37.38-2.86-39.42-3.83l-0.46-.21a1.89,1.89,0,0,1-1.29-2.36l3.21-8.74a7.45,7.45,0,0,1,6.9-4.85c10.92-.08,16.56-0.06,16.76.05l-0.08.14c-0.28-.1-6.36-0.11-16.68,0a7.28,7.28,0,0,0-6.75,4.75l-3.21,8.74a1.71,1.71,0,0,0,1.19,2.15l0.47,0.21c2,1,8.07,3.82,39.35,3.82l4.41,0a1.62,1.62,0,0,0,1.35-2.48l-0.92-1.45a14.51,14.51,0,0,1-2.25-7.43l-0.15-6.56H145l0.15,6.56a14.35,14.35,0,0,0,2.23,7.35l0.92,1.45a1.78,1.78,0,0,1-1.49,2.73Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M153.59,826.89l-0.15-.06,0.36-.84a3.78,3.78,0,0,1,3.48-2.31h0.45a3.08,3.08,0,0,0,2.81-1.82,25.61,25.61,0,0,1,1.59-3l0-.07a9.22,9.22,0,0,1,7.21-4.28,118.89,118.89,0,0,1,12.58-.19v0.16a118.72,118.72,0,0,0-12.56.19,9.05,9.05,0,0,0-7.08,4.21l0,0.07a25.45,25.45,0,0,0-1.58,3,3.24,3.24,0,0,1-3,1.91h-0.45a3.62,3.62,0,0,0-3.34,2.21Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M175.85,829.16c-4.62,0-9.41-.14-11.76-0.22a1.12,1.12,0,0,1-1.08-1.23,21.53,21.53,0,0,1,6.2-13.18l0.11,0.12a21.36,21.36,0,0,0-6.15,13.08,1,1,0,0,0,.92,1c10.6,0.35,22.2.37,23-.65a0.11,0.11,0,0,0,0-.11c-0.86-2.54-.35-12.69-0.33-13.12h0.16c0,0.11-.53,10.55.32,13.06a0.27,0.27,0,0,1,0,.26C186.64,829,181.37,829.16,175.85,829.16Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M160.51,828.35h-0.16c0-.07,1.21-8.12,7.13-13.5l0.11,0.12C161.7,820.32,160.52,828.27,160.51,828.35Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M80.83,801.54h-0.1l-3.53-.46-1.77-.23-3.31-.44L69.34,800l-2.53-.35c-4.78-.66-4.9-0.74-5-0.78l-0.12-.07v-0.14a36.67,36.67,0,0,1,5.17.52l2.52,0.35,2.79,0.38,3.3,0.44,1.77,0.23L80.7,801c1.68-1.28,3.08-2.67,3-3-0.76-.48-3-1.44-3-1.45l-0.53-.22,3.52-1.46-1.28-4,3.82,2.79v-7.89l2.37,1.37-1-5.56L87,773.89l3.3,9.33,0-.49c-0.08-1.29-.17-2.77-0.24-4.17-0.39-7.16-.26-7.48-0.2-7.62a19.65,19.65,0,0,0,.59-1.92l0.47,0.12a19.66,19.66,0,0,1-.61,2c0,0.14-.1,1.15.24,7.41,0.08,1.4.16,2.88,0.24,4.17s0.14,2.22.14,2.22L91,786.66l-3.24-9.16,0.31,4,1.2,6.55-2.56-1.48v8l-3.4-2.48,1,3.07-2.86,1.19A24.74,24.74,0,0,1,84,797.65a0.46,0.46,0,0,1,.22.38c0,0.87-2.51,2.86-3.28,3.45Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref52 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "74.44 64.36 61.41 54.1 56.5 50.89 54.12 49.21 54.4 48.82 56.77 50.49 61.7 53.71 74.44 64.36"
});

var _ref53 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "28.31 54.99 26.83 52.27 28.27 50.33 22.28 49.85 29.23 49.85 27.41 52.31 28.31 54.99"
});

var _ref54 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "53.47 35.28 53.4 34.8 79.96 31.82 53.47 35.28"
});

var _ref55 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M71.27,805.76c0.31-.34,2.76-3.62,4-5.31l0.39,0.29C75.51,800.94,71.27,805.76,71.27,805.76Z",
  transform: "translate(-55.1 -764.22)"
});

var _ref56 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "27.54 50.86 34.88 44.16 32.18 44.16 32.97 39.49 30.82 39.25 33.19 36.79 25.86 37.3 24.56 40.85 25.47 36.84 34.41 36.22 31.85 38.88 33.54 39.06 32.75 43.68 36.13 43.68 29.95 49.32 42.46 44.03 53.77 48.56 48.85 38.35 52.81 35.22 48.09 34.78 50.46 31.68 47.27 30.31 55.12 26.1 47.5 27.56 47.5 24.11 43.8 25.39 40.3 22.23 37.69 23.04 38.96 18.33 35.69 22.12 35.33 21.8 39.98 16.42 38.39 22.32 40.42 21.69 43.91 24.84 47.98 23.43 47.98 26.98 58.14 25.03 48.38 30.26 51.22 31.48 49 34.38 54.06 34.85 49.46 38.49 54.74 49.47 42.46 44.55 27.54 50.86"
});

var _ref57 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "20.28 38.81 25.58 36.84 25.75 37.29 20.28 38.81"
});

var _ref58 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "28.19 39.06 33.69 36.29 33.91 36.72 28.19 39.06"
});

var _ref59 =
/*#__PURE__*/
React.createElement("rect", {
  className: "cls-1",
  x: 101.77,
  y: 789.14,
  width: 5.24,
  height: 0.48,
  transform: "translate(-648.77 -357.89) rotate(-53.71)"
});

var _ref60 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "44.08 25.19 43.62 25.04 45.3 19.82 44.08 25.19"
});

var _ref61 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "50.93 31.81 50.76 31.36 57.17 28.98 50.93 31.81"
});

var _ref62 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "31.12 30 29.63 26.63 29.63 23.37 16.09 8.19 30.11 23.18 30.11 26.53 31.56 29.81 31.12 30"
});

var _ref63 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M97.81,814.64c0-.27-0.3-3.54-0.42-5.18L96.21,812l-1.77.88-0.22-.43,1.62-.81,2-3.16C97.92,810.09,97.81,814.64,97.81,814.64Z",
  transform: "translate(-55.1 -764.22)"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    viewBox: "0 0 207.9 78.13"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63);
};

export default __webpack_public_path__ + "static/media/icon-shorttime-accident.a246388b.svg";
export { SvgComponent as ReactComponent };